import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import Brands from './SettingsComponents/Brand';
import Categories from './SettingsComponents/Category';
import EquipmentAttachmentTypes from './SettingsComponents/EquipmentAttachmentType';
import EquipmentModels from './SettingsComponents/EquipmentModel';
import EquipmentStatuses from './SettingsComponents/EquipmentStatus';
import ExpenseTypes from './SettingsComponents/ExpenseType';

export default function SettingsPage() {
  const { authorizedUser } = useSelector(
    ({ auth }) => ({
      authorizedUser: auth.user,
    }),
    shallowEqual
  );
  return (
    <div>
      <Categories authorizedUser={authorizedUser} />
      <br></br>
      <Brands authorizedUser={authorizedUser} />
      <br></br>
      <EquipmentModels />
      <br></br>
      <EquipmentStatuses authorizedUser={authorizedUser} />
      <br></br>
      <ExpenseTypes authorizedUser={authorizedUser} />
      <br></br>
      <EquipmentAttachmentTypes />
    </div>
  );
}
